import { render, staticRenderFns } from "./BetBalanceMenu.vue?vue&type=template&id=49b0489a&"
import script from "./BetBalanceMenu.vue?vue&type=script&lang=js&"
export * from "./BetBalanceMenu.vue?vue&type=script&lang=js&"
import style0 from "./BetBalanceMenu.vue?vue&type=style&index=0&id=49b0489a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports